import React from 'react';
import {
  string,
  shape,
  number,
} from 'prop-types';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { formatDistance } from '../../../helper/utils';

const InStockNearByStore = ({ nearByStoreLocation }) => (
  <div className="fulfillment-tile">
    <TileHead title="Pickup Nearby" />
    <div className="fulfillment__sub-title">
      <div className="u__bold">Today</div>
      <div className="u__text--success fulfillment-qty-row">
        {`In stock ${formatDistance(nearByStoreLocation?.distance)} mi away`}
      </div>
    </div>
    <TileFooter className="u__bold">
      <span className="u__text--success">FREE</span>
    </TileFooter>
  </div>
);

InStockNearByStore.propTypes = {
  nearByStoreLocation: shape({
    storeName: string,
    distance: number
  }).isRequired,
};

InStockNearByStore.defaultProps = {
};

export { InStockNearByStore };
